<form [formGroup]="nestedForm">
  <dq-action-bar
    (edit)="onEdit()"
    (validate)="onValidate()"
    (cancel)="onCancel()"
    (save)="onSave()"
    [editMode]="editMode"
    [pos]="posSelected"
    [showEdit]="showEditActionButton"
  ></dq-action-bar>
  <div id="detailPosDiv" class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <dq-pos-general-data
          [editMode]="editMode"
          [posSelected]="posSelected"
          [generalDataForm]="generalDataForm"
          [preferredsCallTime]="preferredsCallTime"
          [posTypes]="posTypes"
        ></dq-pos-general-data>
        <dq-pos-products
          [products]="products$ | async"
          [brands]="brand$ | async"
          [lines]="line$ | async"
          [formats]="format$ | async"
          [subbrands]="subbrand$ | async"
          (filterChange)="onFilterChange($event)"
          (sort)="onSort($event)"
        ></dq-pos-products>
      </div>
      <div class="col-md-4">
        <dq-pos-location-data
          [editMode]="editMode"
          [posSelected]="posSelected"
          [locationForm]="locationForm"
        ></dq-pos-location-data>
        <dq-pos-brands [brands]="brand$ | async"></dq-pos-brands>
      </div>
    </div>
  </div>
</form>
<br />
